import '../scss/style.scss'

import { 
  mobileMenuToggle,
  AccessibleMenu,
  searchCategory,
  fadeInScroll,
  counterAnimation 
} from './components';

mobileMenuToggle();
fadeInScroll();


if (document.querySelector('.js-counter')){
  counterAnimation();
}


if (document.querySelector('#js-cat-list')){
  searchCategory(document.querySelector('#js-cat-list'))
}

if (document.querySelectorAll('#js-nav')){
  new AccessibleMenu('#js-nav')
}

